import { render, staticRenderFns } from "./LayoutCenter1C.vue?vue&type=template&id=55b545e4"
import script from "./LayoutCenter1C.vue?vue&type=script&lang=js"
export * from "./LayoutCenter1C.vue?vue&type=script&lang=js"
import style0 from "./LayoutCenter1C.vue?vue&type=style&index=0&id=55b545e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports